<template>
    <a :class="{'nav-link' : !scrolled}" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <i class="fa" :class="{'fa-heart-o': !wishListCount, 'fa-heart': wishListCount}" aria-hidden="true"></i>
        <span class="" v-if="!scrolled">{{ $translate("Ceres::Template.wishList") }}</span>
    </a>
</template>

<script>
export default {
    props: {
        scrolled: {
            type: Boolean,
            default: false
        }
    },
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
